import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseItemContrastOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-contrast-option';
import {useAppSelector} from '@/hooks';

export function ImageBgContrastOption(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const updateContrast = (contrast: number, undoable?: boolean): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          imageBackgroundItemObject: {
            effects: {
              contrast,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemContrastOption contrast={currentPageObject.background.details.imageBackgroundItemObject.effects.contrast} updateContrast={updateContrast} />;
}
